// extracted by mini-css-extract-plugin
export var modal = "_kz-0";